import { Component, Input, NgZone, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import {ActivatedRoute, NavigationExtras, RoutesRecognized } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { Platform } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-pet-food',
  templateUrl: './pet-food.page.html',
  styleUrls: ['./pet-food.page.scss'],
})
export class PetFoodPage implements OnInit {
  userId: any;
  productList: any = [];
  category: any = "";
  page_number: number = 1;
  limit = 20;
  searchParams: String;
  searchResultData: any = [];
  noDataImage: boolean = false;
  locationFlag: any = 0;
  address: string;
  latitude: number;
  longitude: number;
  accuracy: number;
  subCategory: any;
  isLoading: boolean = false;
  productFound: boolean = false;
  pin: any;
  city= localStorage.getItem('city');
  isPromoActiveFlag: any;
  storeDetail: any;
  recommendflag: any;
  first: boolean;
  count: any;
  search: boolean = false;
  resultsAvailable: boolean = false;
  page: any;
  myObj2: any;
  filterO = 1;
  a: any;
  discount: any = "0";
  price: any = "0-10000000";
  filterData: any;
  length: any;
  check: any = 0;
  offset: any = 0;
  //Edit by Sharaddha
  cart: any = [];
  qty: number = 1;
  show: any;
  userAddress: string = ''
  userLatitude: string = ''
  userLongitude: string = ''
  addressDisplay: any;
  googlemap: any;
  isItemAvailable: boolean;
  ipaddress: any;
  merChat: any;
  bannerImg: any;
  middleImgbottom: any;
  recommendedProducts: any[];
  productListA: any;
  n: any;
  productListI: any;
  metaDescription=localStorage.getItem('metaDescription');
   constructor(public title: Title, private meta: Meta, private renderer: Renderer2, private userService: UserService,private authService : StoreService, private toast : ToastService, private router : Router,
  
      private routerActivate: ActivatedRoute,
      public alertController : AlertController,
   
      private service: StoreService,
      private appVersion: AppVersion,
      private platform: Platform,
      public actionSheetController: ActionSheetController,
      private _platform: Platform,
      private ngZone: NgZone,
     ) {
        this.userService.cartUpdated.subscribe(res => {
          let cart = localStorage.getItem('cart');
          if(cart){
            this.n = JSON.parse(cart).length;
          }
        })
       }
 

  ngOnInit() {
    this.listProduct();
    this.userService.appSettings.subscribe((resp:any) => {
      console.log("appSettings resp version ", resp.version);
      if(resp && resp.checkVersion && resp.version){
        console.log("resp.version ", resp.version);
        this.appVersion.getVersionNumber().then(version => {
          console.log("this.appVersion.getVersionNumber() ", version);
          if(resp.version != version){
            // this.updateAlertConfirm();
          }
        });
      }
    })
    if (!localStorage.getItem('city')) {
      this.AddController();
    }
    this.fetchProductLimit();
    this.topBannerImage();
    // this.middleBannerImage();

    this.city = localStorage.getItem('city')
    this.pin = localStorage.getItem('pin')
    this.topBannerImage();
    this.merchantCatList()
     // Edit By vikash Kumar
  // Location Api display in navbar
    const value=localStorage.getItem('city');
           if (value){
            this.city=value
            // document.getElementById('modal').style.display='none';
          
           } 
  else{
    this.getP()
  }
  const canonicalUrl = 'https://spotyourdeal.com/pet-food'; // canonical URL
  
  const link = this.renderer.createElement('link');
  this.renderer.setAttribute(link, 'rel', 'canonical');
  this.renderer.setAttribute(link, 'href', canonicalUrl);
  this.renderer.appendChild(document.head, link);
  const pageTitle = `SpotYourDeal - Pet Food | Buy Pet Food and Accessories Online at Best Price | PetVays`;
  this.title.setTitle(pageTitle);
  this.meta.addTags([
     
    // Meta robots
    { name: "robots", content: "index,follow" },
    // OG Tag Facebook
    { property: "og:type", content: "website" },
    { property: "og:url", content: canonicalUrl },
    { property: "og:title", content:  pageTitle},
    { property: "og:description", content: this.metaDescription},
 
]);
  }
  
  listProduct() {
    let formdata =
      { "cat": "Pet Food", "page": 1, "limit": 14, "productId": "", "cityName": "Delhi", "bannerType": "M7", "userId": this.userId, "storeId": ["Pet6197"], "zip": "", "articleNumber": [] }
    console.log("Response from formdata of productlist", formdata)
    this.service.todaySepicalOffer(formdata).subscribe((data) => {
      this.productListI = data["msg"];
      const products =  this.productListI;
      console.log("product detail API hit1", products)

      // SEO
      let metaDescription = '';
      let keywords="";
      products.forEach((product: any) => {
        metaDescription += `${product.name}, `;
        keywords += `${product.name}, `;
      });
      metaDescription = metaDescription.slice(0, -2);
      this.meta.updateTag({ name: 'keywords', content: keywords });
    
    
      // Update the meta tag description
      this.meta.updateTag({ name: 'description', content: metaDescription });
      localStorage.setItem('metaDescription', metaDescription);
      
      let Imagepath = '';
      products.forEach((product: any) => {
        Imagepath += `${product.Imagepath}, `;
      });
      this.meta.updateTag({ property: 'og:image', content: Imagepath });

      // END SEO
    })
  }
 
 
   handleAddToCart(productObj) {
     let promoListobj = {
       productdetails: productObj,
       userId: this.userId
     }
    
     this.authService.addToCart(promoListobj)
       .subscribe((result: any) => {
         this.toast.presentToast("Product added in your cart")
       }, (error: any) => {
       });
   }
   
   productDetail(productItem: any) {
     console.log("hello hi ", productItem)
     this.router.navigate(['./product-detail/'+productItem._id])
   }
  
 
   // onImageLoad(item){
   //   console.log("hii")
   //   item.image=true;
   //   this.loading=true;
   //   if(item.image==true){
   //     this.a='visible'
   //   }
   //   else{
   //     this.a='none'
   //   }
   // }
 
   handleMissingImage($event){
     console.log($event)
     console.log("hello error");
     ($event.target as HTMLImageElement).style.display = 'none'
     this.a=true;
   }
  
   isRetailer(){
     if(localStorage.getItem('retailerEnabled')=="1") 
      return true;
    }

  
  
    fetchCatStoreTerm() {
      let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
      this.router.navigate(['/search-product'], navigationParams);
    }
  
    wishlist() {
      this.router.navigate(['/wishlist'])
    }
    Myprofile(){
      this.router.navigate(['/profile'])
    }
  
    cart1() {
      this.router.navigate(['/cart'])
    }
  
    loginmobile() {
      this.router.navigate(['/account-page'])
    }
    nearby(){
      this.router.navigate(['/nearby'])
    }
    wallet(){
      this.router.navigate(['/spot-wallet'])
    }
  
    async AddController() {
      const actionSheet = await this.actionSheetController.create({
        header: 'Choose Location',
        cssClass: 'action-search-custom-class',
        buttons: [
          // {
          //   text: 'Zip Code',
          //   icon: 'pin-outline',
          //   handler: () => {
          //     this.locationFlag = 2;
          //     this.page_number = 1;
          //     this.enterSerachkeyword(this.locationFlag)
          //     console.log('Share clicked');
          //   }
          // }, 
          {
            text: 'City',
            icon: 'business-outline',
            handler: () => {
              this.locationFlag = 3;
              this.page_number = 1;
              // this.enterSerachkeyword(this.locationFlag)
              this.enterCityRadio(this.locationFlag)
              console.log('Play clicked');
            }
          }
        ]
      });
      await actionSheet.present();
  
      const { role } = await actionSheet.onDidDismiss();
    }
    fetchProductLimit() {
      const proObj = {}
      this.service.webProductCat(proObj).subscribe((result: any) => {
  
        this.productListA = result.msg
        console.log(this.productListA)
      }, (error: any) => {
        this.toast.presentToast(error)
      });
    }
    topBannerImage() {
      this.service.topBannerImg().subscribe((result: any) => {
        console.log("Response banner image", result)
        this.bannerImg = result
        this.merchantCatList()
      }, (error: any) => {
        this.toast.presentToast(error)
  
      });
    }
  
    middleBannerImage(city:any) {
      let that = this;
      const DisObj = {
        city: this.city
      }
      this.service.middleBannerImg1(DisObj).subscribe((result: any) => {
  
        this.ngZone.run(() => {
          console.log("result ", result)
          that.middleImgbottom = result;
          console.log("that.middleImgbottom ", that.middleImgbottom)
        });
  
      }, (error: any) => {
  
      });
    }
    async enterCityRadio(flag: number) {
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Select City',
        inputs: [{
            name: 'radio1',
            type: 'radio',
            label: 'Kanpur',
            value: 'Kanpur',
  
          },
          {
            name: 'radio1',
            type: 'radio',
            label: 'Lucknow',
            value: 'Lucknow',
            // handler: () => {
            //   console.log('Radio 1 selected');
            // },
          },
          {
            name: 'radio1',
            type: 'radio',
            label: 'Delhi NCR',
            value: 'Delhi NCR',
  
          },
        ],
        buttons: [{
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
  
            //  console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'OK',
          handler: (data) => {
            if (flag == 3) {
              //flag use for enter "city" keyword
              this.productList = [];
              this.page_number = 1;
              localStorage.setItem('city', data);
              this.city = data;
              localStorage.setItem('pin', '');
              this.pin = null;
              console.log('Confirm flag == 3', this.city);
              this.recommendedProducts = [];
              this.middleBannerImage(this.city);
              //this.recommandedProductList();
            }
            window.location.reload();
          }
        }]
      });
  
      await alert.present();
    }
    merchantCatList() {
      this.service.preDifnedCat().subscribe((result: any) => {
        console.log("Response from merchandied catagories", result)
        this.merChat = result
  
      }, (error: any) => {
        this.toast.presentToast(error)
      });
    }
    app(){
      window.open("https://play.google.com/store/apps/details?id=com.spot.mckinsol&hl=en_IN&gl=US")
    }
    fetchCatStoreTerm1() {
      let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
      this.router.navigate(['/search-product'], navigationParams);
    }
    reload(){
      window.location.reload()
    }
    isModalOpen = false;

    setOpen(isOpen: boolean) {
      this.isModalOpen = isOpen;
      this.filterO = this.filterO * (-1)
      console.log(this.filterO)
      if (this.filterO == 1) {
        this.a = 10
      } else {
        this.a = 125;
      }
    }
    isModalOpen1 = false;
  
  setOpen1(isOpen: boolean) {
    this.isModalOpen = isOpen; 
  }
  
   filter() {
      this.filterO = this.filterO * (-1)
      console.log(this.filterO)
      if (this.filterO == 1) {
        this.a = 10
      } else {
        this.a = 125;
      }
    }
  
    filterSubmit() {
      let formData = {
        city: this.city,
        cat: this.category,
        subcat: this.subCategory,
        limit: this.limit,
        offset: 0
      }
  
      if (this.price != "")
        formData['price'] = this.price.split("-");
  
      if (this.discount != 0)
        formData['discount'] = this.discount;
  
      this.authService.getProduct(formData).subscribe(res => {
        this.filterData = res;
        this.productList = this.filterData;
        this.length = res.length;
        this.filterO = 1;
        this.a = 20;
        if (this.productList.length > 0) {
          this.check = 0;
        } else {
          this.check = 1;
        }
      })
    }

    onClickSegment(event) {
      console.log("event hi",event)
    }
    getLocation(ev: any) {
      console.log('i m ')
      const val = ev.target.value;
      if (val && val.trim() !== '') {
          this.isItemAvailable = true;
        
          this.authService.addressLookup({value:val}).subscribe((data)=>{
            this.googlemap=data;
            // console.log("ee",data)
            console.log("response google map", this.googlemap)})
         
          } else {
            this.isItemAvailable = false;
          }
          
        }
        
        change(val) {
          const searchbox = document.getElementById('popover');
          console.log(searchbox,'hjh..')
          searchbox.style.display = 'none';
      this.city = val.split(',')[0]; ;
      localStorage.setItem('city', this.city)
      // document.getElementById('trigger-button').style.display='none';
      this.middleBannerImage(this.city)
      location.reload() 
    }
    getP(){
      console.log("i am hit")
    this.authService.getIpAddress().subscribe(res => {
    
      this.ipaddress = res['ip'];
      console.log("ip")
      this.authService.getGEOLocation(this.ipaddress).subscribe(res => {
    console.log(res);
       this.city = res['city'];
       localStorage.setItem('city', this.city)
       // document.getElementById('trigger-button').style.display='none';
       this.middleBannerImage(this.city)
      });
      //console.log(res);
    
    });}
    handleAddToCarta(productObj) {
      console.log("productObj ", productObj)
  
      this.cart = []
      if (productObj.qty) {///Added by Parul
        ++productObj.qty
      }
      else {
        productObj['qty'] = 1;
      }
      let cart = localStorage.getItem("cart");
      if (cart) {
        this.cart = JSON.parse(cart);
        console.log("cart ", this.cart)
        let filtered = this.cart.filter(product => product.id == productObj._id)
        console.log("filtered ", filtered)
        if (filtered.length == 0) {
          var pdata = {
            id: productObj._id,
            qty: this.qty
          }
          console.log(pdata)
          this.cart.push(pdata)
          localStorage.setItem('cart', JSON.stringify(this.cart))
          // this.show = 1
        } else {
          console.log(this.show)
          let index = this.cart.indexOf(filtered[0]);
          console.log("index ", index)
          this.cart[index]['qty'] = productObj.qty;//Added by Parul
          // this.cart.splice(index, 1)
          localStorage.setItem('cart', JSON.stringify(this.cart))
          // this.show = null
  
        }
      } else {
        console.log("item._id ", productObj._id)
        var pdata = {
          id: productObj._id,
          qty: this.qty
        }
        this.cart.push(pdata)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        this.show = 1
      }
      this.userService.cartUpdated.next(true);
    }
  
    deleteFromCart(item) {
      if (item.qty > 0) {
        --item.qty;
        this.cart = []
        let cart = localStorage.getItem("cart");
        if (cart) {
          this.cart = JSON.parse(cart);
          console.log("cart ", this.cart)
          let filtered = this.cart.filter(product => product.id == item._id)
          let index = this.cart.indexOf(filtered[0])
          this.cart[index]['qty'] = item.qty;
          if (item.qty == 0) {
            this.cart.splice(index, 1)
          }
          localStorage.setItem('cart', JSON.stringify(this.cart))
          this.userService.cartUpdated.next(true);
        }
        // this.loadCartItems();
  
      }
    }
}

